interface UseShortcutInterface {
    key: string,
    callBack: Function,
    ctrlKey?: boolean | undefined,
    altKey?: boolean | undefined,
    shiftKey?: boolean | undefined,
}

function useShortcut(props: UseShortcutInterface): void {
    document.addEventListener("keydown", (ev) => {
        if (ev.key === props.key
            && ev.ctrlKey === (props.ctrlKey ?? false)
            && ev.altKey === (props.altKey ?? false)
            && ev.shiftKey === (props.shiftKey ?? false)
        ) {
            ev.preventDefault();
            props.callBack();
        }
    })
}

export default useShortcut;